export class GetCards {
    public static readonly type = '[Cards] Get cards';
}
